var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6238 7.0706C20.4168 6.25554 19.8066 5.61365 19.0326 5.3953C17.6286 5 12 5 12 5C12 5 6.3714 5 4.9674 5.3953C4.1934 5.61365 3.5832 6.25554 3.3762 7.0706C3 8.54826 3 11.6316 3 11.6316C3 11.6316 3 14.7149 3.3762 16.1926C3.5832 17.0076 4.1934 17.6495 4.9674 17.8679C6.3714 18.2632 12 18.2632 12 18.2632C12 18.2632 17.6286 18.2632 19.0326 17.8679C19.8066 17.6495 20.4168 17.0076 20.6238 16.1926C21 14.713 21 11.6316 21 11.6316C21 11.6316 21 8.54826 20.6238 7.0706ZM10.1586 14.4288V8.8325L14.8638 11.6316L10.1586 14.4288Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.2a484aa9.svg";
export { ForwardRef as ReactComponent };